//
// Copyright (c) 2016 Practice Insight Pty Ltd. All rights reserved.
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wt/svc/customer/user_team.proto (package pi_customer_public, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../../../google/api/annotations_pb";
import type { Authority, Currency, ManagementSystemType, SubscriberState, TeamType } from "../shared/shared_pb";
import { file_wt_svc_shared_shared } from "../shared/shared_pb";
import type { DataRetentionPeriod } from "../../../wisetime/type/data_retention_pb";
import { file_wisetime_type_data_retention } from "../../../wisetime/type/data_retention_pb";
import type { SeatAllocationPolicy } from "../../../wisetime/type/seat/seat_policy_pb";
import { file_wisetime_type_seat_seat_policy } from "../../../wisetime/type/seat/seat_policy_pb";
import type { DirectTimelinePostPreference, RoundingPreference } from "../../../wisetime/type/site_preferences_pb";
import { file_wisetime_type_site_preferences } from "../../../wisetime/type/site_preferences_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wt/svc/customer/user_team.proto.
 */
export const file_wt_svc_customer_user_team: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_wt_svc_shared_shared, file_wisetime_type_data_retention, file_wisetime_type_seat_seat_policy, file_wisetime_type_site_preferences]);

/**
 * @generated from message pi_customer_public.CreateTeamRequest
 */
export type CreateTeamRequest = Message<"pi_customer_public.CreateTeamRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message pi_customer_public.CreateTeamRequest.
 * Use `create(CreateTeamRequestSchema)` to create a new message.
 */
export const CreateTeamRequestSchema: GenMessage<CreateTeamRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 0);

/**
 * @generated from message pi_customer_public.CreateTeamResponse
 */
export type CreateTeamResponse = Message<"pi_customer_public.CreateTeamResponse"> & {
  /**
   * @generated from field: string teamId = 1;
   */
  teamId: string;

  /**
   * @generated from field: pi_customer_public.CreateTeamStatus status = 2;
   */
  status: CreateTeamStatus;
};

/**
 * Describes the message pi_customer_public.CreateTeamResponse.
 * Use `create(CreateTeamResponseSchema)` to create a new message.
 */
export const CreateTeamResponseSchema: GenMessage<CreateTeamResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 1);

/**
 * @generated from message pi_customer_public.GetTeamRequest
 */
export type GetTeamRequest = Message<"pi_customer_public.GetTeamRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;
};

/**
 * Describes the message pi_customer_public.GetTeamRequest.
 * Use `create(GetTeamRequestSchema)` to create a new message.
 */
export const GetTeamRequestSchema: GenMessage<GetTeamRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 2);

/**
 * @generated from message pi_customer_public.GetTeamResponse
 */
export type GetTeamResponse = Message<"pi_customer_public.GetTeamResponse"> & {
  /**
   * Empty if team was not found
   *
   * @generated from field: pi_customer_public.TeamProto team = 1;
   */
  team?: TeamProto;
};

/**
 * Describes the message pi_customer_public.GetTeamResponse.
 * Use `create(GetTeamResponseSchema)` to create a new message.
 */
export const GetTeamResponseSchema: GenMessage<GetTeamResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 3);

/**
 * @generated from message pi_customer_public.TeamProto
 */
export type TeamProto = Message<"pi_customer_public.TeamProto"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string logo_url = 3;
   */
  logoUrl: string;

  /**
   * data retention set by user, can be MAX_ELIGIBLE.
   *
   * @generated from field: wisetime.type.DataRetentionPeriod data_retention_period = 5;
   */
  dataRetentionPeriod: DataRetentionPeriod;

  /**
   * effective team data retention. If data_retention_period is MAX_ELIGIBLE
   * then resolved_data_retention_period is set to evaluated value based on team plan,
   * otherwise resolved_data_retention_period is same as data_retention_period.
   *
   * @generated from field: wisetime.type.DataRetentionPeriod resolved_data_retention_period = 13;
   */
  resolvedDataRetentionPeriod: DataRetentionPeriod;

  /**
   * @generated from field: bool tag_required_to_post_time = 6;
   */
  tagRequiredToPostTime: boolean;

  /**
   * @generated from field: wisetime.type.seat.SeatAllocationPolicy seat_policy = 19;
   */
  seatPolicy: SeatAllocationPolicy;

  /**
   * see enum comments as to usage
   *
   * @generated from field: pi_customer_public.IncludeActivityDefault include_activity_default = 14;
   */
  includeActivityDefault: IncludeActivityDefault;

  /**
   * @generated from field: pi_customer_public.SubscriberInfo subscriber_info = 18;
   */
  subscriberInfo?: SubscriberInfo;

  /**
   * Deprecated, use rounding_preference_sec instead
   *
   * @generated from field: wisetime.type.RoundingPreference team_rounding_preference = 20 [deprecated = true];
   * @deprecated
   */
  teamRoundingPreference: RoundingPreference;

  /**
   * @generated from field: int32 rounding_preference_sec = 23;
   */
  roundingPreferenceSec: number;

  /**
   * @generated from field: wisetime.type.DirectTimelinePostPreference direct_timeline_post_preference = 21;
   */
  directTimelinePostPreference: DirectTimelinePostPreference;

  /**
   * When set to true, this flag prevents sending team invites or join requests.
   * This is typically used to restrict team membership changes in certain scenarios, such as
   * when team members are managed by an external system.
   *
   * @generated from field: bool prevent_team_invites_and_join_requests = 22;
   */
  preventTeamInvitesAndJoinRequests: boolean;
};

/**
 * Describes the message pi_customer_public.TeamProto.
 * Use `create(TeamProtoSchema)` to create a new message.
 */
export const TeamProtoSchema: GenMessage<TeamProto> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 4);

/**
 * @generated from message pi_customer_public.SubscriberInfo
 */
export type SubscriberInfo = Message<"pi_customer_public.SubscriberInfo"> & {
  /**
   * @generated from field: string subscriber_id = 1;
   */
  subscriberId: string;

  /**
   * @generated from field: wt_srv_shared.TeamType type = 2;
   */
  type: TeamType;

  /**
   * NONE - allow to create stripe subscription (get CC+Currency from customer);
   *        don't allow to `Update CC` (allow update for AUTO_CREDIT_CARD); don't allow change paid plan
   * BANK_TRANSFER - don't allow create subscriber; don't allow `Update CC`; don't allow change paid plan
   * AUTO_CREDIT_CARD - don't allow to create subscriber;  allow `Update CC`; allow change paid plan
   *
   * @generated from field: pi_customer_public.SubscriberInfo.PaymentMethod payment_method = 5;
   */
  paymentMethod: SubscriberInfo_PaymentMethod;

  /**
   * @generated from field: wt_srv_shared.Currency currency = 6;
   */
  currency: Currency;

  /**
   * @generated from field: wt_srv_shared.SubscriberState state = 7;
   */
  state: SubscriberState;

  /**
   * sec since Epoch when subscriber is scheduled to be set to a TRASHED state
   * is only set when the subscriber is in a RESTRICTED state
   *
   * @generated from field: uint64 trash_at_utc = 8;
   */
  trashAtUtc: bigint;

  /**
   * ids of teams linked to this subscriber
   *
   * @generated from field: repeated string linked_team_ids = 9;
   */
  linkedTeamIds: string[];

  /**
   * channel partner code used on team creation
   *
   * @generated from field: string channel_partner_code = 10;
   */
  channelPartnerCode: string;
};

/**
 * Describes the message pi_customer_public.SubscriberInfo.
 * Use `create(SubscriberInfoSchema)` to create a new message.
 */
export const SubscriberInfoSchema: GenMessage<SubscriberInfo> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 5);

/**
 * @generated from enum pi_customer_public.SubscriberInfo.PaymentMethod
 */
export enum SubscriberInfo_PaymentMethod {
  /**
   * @generated from enum value: PAYMENT_METHOD_UNSPECIFIED = 0;
   */
  PAYMENT_METHOD_UNSPECIFIED = 0,

  /**
   * @generated from enum value: NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: AUTO_CREDIT_CARD = 2;
   */
  AUTO_CREDIT_CARD = 2,

  /**
   * @generated from enum value: BANK_TRANSFER = 3;
   */
  BANK_TRANSFER = 3,
}

/**
 * Describes the enum pi_customer_public.SubscriberInfo.PaymentMethod.
 */
export const SubscriberInfo_PaymentMethodSchema: GenEnum<SubscriberInfo_PaymentMethod> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 5, 0);

/**
 * only the idToken required
 *
 * @generated from message pi_customer_public.GetMyTeamsRequest
 */
export type GetMyTeamsRequest = Message<"pi_customer_public.GetMyTeamsRequest"> & {
};

/**
 * Describes the message pi_customer_public.GetMyTeamsRequest.
 * Use `create(GetMyTeamsRequestSchema)` to create a new message.
 */
export const GetMyTeamsRequestSchema: GenMessage<GetMyTeamsRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 6);

/**
 * @generated from message pi_customer_public.GetMyTeamsResponse
 */
export type GetMyTeamsResponse = Message<"pi_customer_public.GetMyTeamsResponse"> & {
  /**
   * teams where the user's status is active
   *
   * @generated from field: repeated pi_customer_public.MyTeam my_teams = 1;
   */
  myTeams: MyTeam[];

  /**
   * teams where the user's status is inactive (i.e. user left the team but didn't invoke the right to be forgotten).
   *
   * @generated from field: repeated pi_customer_public.MyTeam departed_teams = 2;
   */
  departedTeams: MyTeam[];
};

/**
 * Describes the message pi_customer_public.GetMyTeamsResponse.
 * Use `create(GetMyTeamsResponseSchema)` to create a new message.
 */
export const GetMyTeamsResponseSchema: GenMessage<GetMyTeamsResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 7);

/**
 * @generated from message pi_customer_public.MyTeam
 */
export type MyTeam = Message<"pi_customer_public.MyTeam"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string logo_url = 3;
   */
  logoUrl: string;

  /**
   * @generated from field: wisetime.type.DataRetentionPeriod max_data_retention_period = 4;
   */
  maxDataRetentionPeriod: DataRetentionPeriod;

  /**
   * @generated from field: wt_srv_shared.Authority authority = 5;
   */
  authority: Authority;

  /**
   * @generated from field: bool is_last_active_member = 6;
   */
  isLastActiveMember: boolean;

  /**
   * @generated from field: wt_srv_shared.TeamType team_type = 7;
   */
  teamType: TeamType;

  /**
   * @generated from field: bool is_last_owner = 8;
   */
  isLastOwner: boolean;
};

/**
 * Describes the message pi_customer_public.MyTeam.
 * Use `create(MyTeamSchema)` to create a new message.
 */
export const MyTeamSchema: GenMessage<MyTeam> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 8);

/**
 * @generated from message pi_customer_public.UpdateTeamRequest
 */
export type UpdateTeamRequest = Message<"pi_customer_public.UpdateTeamRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: wisetime.type.DataRetentionPeriod data_retention_period = 3;
   */
  dataRetentionPeriod: DataRetentionPeriod;

  /**
   * @generated from field: bool tag_required_to_post_time = 4;
   */
  tagRequiredToPostTime: boolean;

  /**
   * Need to notify agent when time is posted?
   *
   * @generated from field: pi_customer_public.IncludeActivityDefault include_activity_details_default = 7;
   */
  includeActivityDetailsDefault: IncludeActivityDefault;
};

/**
 * Describes the message pi_customer_public.UpdateTeamRequest.
 * Use `create(UpdateTeamRequestSchema)` to create a new message.
 */
export const UpdateTeamRequestSchema: GenMessage<UpdateTeamRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 9);

/**
 * @generated from message pi_customer_public.UpdateTeamResponse
 */
export type UpdateTeamResponse = Message<"pi_customer_public.UpdateTeamResponse"> & {
  /**
   * @generated from field: pi_customer_public.UpdateTeamStatus status = 1;
   */
  status: UpdateTeamStatus;
};

/**
 * Describes the message pi_customer_public.UpdateTeamResponse.
 * Use `create(UpdateTeamResponseSchema)` to create a new message.
 */
export const UpdateTeamResponseSchema: GenMessage<UpdateTeamResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 10);

/**
 * @generated from message pi_customer_public.UpdateTeamNameRequest
 */
export type UpdateTeamNameRequest = Message<"pi_customer_public.UpdateTeamNameRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message pi_customer_public.UpdateTeamNameRequest.
 * Use `create(UpdateTeamNameRequestSchema)` to create a new message.
 */
export const UpdateTeamNameRequestSchema: GenMessage<UpdateTeamNameRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 11);

/**
 * @generated from message pi_customer_public.UpdateTeamNameResponse
 */
export type UpdateTeamNameResponse = Message<"pi_customer_public.UpdateTeamNameResponse"> & {
  /**
   * @generated from field: pi_customer_public.UpdateTeamNameStatus status = 1;
   */
  status: UpdateTeamNameStatus;
};

/**
 * Describes the message pi_customer_public.UpdateTeamNameResponse.
 * Use `create(UpdateTeamNameResponseSchema)` to create a new message.
 */
export const UpdateTeamNameResponseSchema: GenMessage<UpdateTeamNameResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 12);

/**
 * @generated from message pi_customer_public.UploadTeamLogoRequest
 */
export type UploadTeamLogoRequest = Message<"pi_customer_public.UploadTeamLogoRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * base64 encoded bytes
   *
   * @generated from field: string image_data = 3;
   */
  imageData: string;
};

/**
 * Describes the message pi_customer_public.UploadTeamLogoRequest.
 * Use `create(UploadTeamLogoRequestSchema)` to create a new message.
 */
export const UploadTeamLogoRequestSchema: GenMessage<UploadTeamLogoRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 13);

/**
 * @generated from message pi_customer_public.UploadTeamLogoResponse
 */
export type UploadTeamLogoResponse = Message<"pi_customer_public.UploadTeamLogoResponse"> & {
  /**
   * @generated from field: string team_logo_url = 1;
   */
  teamLogoUrl: string;
};

/**
 * Describes the message pi_customer_public.UploadTeamLogoResponse.
 * Use `create(UploadTeamLogoResponseSchema)` to create a new message.
 */
export const UploadTeamLogoResponseSchema: GenMessage<UploadTeamLogoResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 14);

/**
 * @generated from message pi_customer_public.SetTeamRoundingPreferenceRequest
 */
export type SetTeamRoundingPreferenceRequest = Message<"pi_customer_public.SetTeamRoundingPreferenceRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * Deprecated, use rounding_preference_sec instead
   *
   * @generated from field: wisetime.type.RoundingPreference team_rounding_preference = 2 [deprecated = true];
   * @deprecated
   */
  teamRoundingPreference: RoundingPreference;

  /**
   * @generated from field: int32 rounding_preference_sec = 3;
   */
  roundingPreferenceSec: number;
};

/**
 * Describes the message pi_customer_public.SetTeamRoundingPreferenceRequest.
 * Use `create(SetTeamRoundingPreferenceRequestSchema)` to create a new message.
 */
export const SetTeamRoundingPreferenceRequestSchema: GenMessage<SetTeamRoundingPreferenceRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 15);

/**
 * @generated from message pi_customer_public.SetTeamRoundingPreferenceResponse
 */
export type SetTeamRoundingPreferenceResponse = Message<"pi_customer_public.SetTeamRoundingPreferenceResponse"> & {
};

/**
 * Describes the message pi_customer_public.SetTeamRoundingPreferenceResponse.
 * Use `create(SetTeamRoundingPreferenceResponseSchema)` to create a new message.
 */
export const SetTeamRoundingPreferenceResponseSchema: GenMessage<SetTeamRoundingPreferenceResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 16);

/**
 * @generated from message pi_customer_public.SetDirectTimelinePostPreferenceRequest
 */
export type SetDirectTimelinePostPreferenceRequest = Message<"pi_customer_public.SetDirectTimelinePostPreferenceRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: wisetime.type.DirectTimelinePostPreference direct_timeline_post_preference = 2;
   */
  directTimelinePostPreference: DirectTimelinePostPreference;
};

/**
 * Describes the message pi_customer_public.SetDirectTimelinePostPreferenceRequest.
 * Use `create(SetDirectTimelinePostPreferenceRequestSchema)` to create a new message.
 */
export const SetDirectTimelinePostPreferenceRequestSchema: GenMessage<SetDirectTimelinePostPreferenceRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 17);

/**
 * @generated from message pi_customer_public.SetDirectTimelinePostPreferenceResponse
 */
export type SetDirectTimelinePostPreferenceResponse = Message<"pi_customer_public.SetDirectTimelinePostPreferenceResponse"> & {
};

/**
 * Describes the message pi_customer_public.SetDirectTimelinePostPreferenceResponse.
 * Use `create(SetDirectTimelinePostPreferenceResponseSchema)` to create a new message.
 */
export const SetDirectTimelinePostPreferenceResponseSchema: GenMessage<SetDirectTimelinePostPreferenceResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 18);

/**
 * @generated from message pi_customer_public.DeleteTeamRequest
 */
export type DeleteTeamRequest = Message<"pi_customer_public.DeleteTeamRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * Delete reason parameters
   *
   * @generated from field: repeated pi_customer_public.TeamDeleteReason delete_reasons = 2;
   */
  deleteReasons: TeamDeleteReason[];

  /**
   * @generated from field: string delete_team_reason_message = 3;
   */
  deleteTeamReasonMessage: string;
};

/**
 * Describes the message pi_customer_public.DeleteTeamRequest.
 * Use `create(DeleteTeamRequestSchema)` to create a new message.
 */
export const DeleteTeamRequestSchema: GenMessage<DeleteTeamRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 19);

/**
 * @generated from message pi_customer_public.DeleteTeamResponse
 */
export type DeleteTeamResponse = Message<"pi_customer_public.DeleteTeamResponse"> & {
};

/**
 * Describes the message pi_customer_public.DeleteTeamResponse.
 * Use `create(DeleteTeamResponseSchema)` to create a new message.
 */
export const DeleteTeamResponseSchema: GenMessage<DeleteTeamResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 20);

/**
 * @generated from message pi_customer_public.ListTeamInvitationsRequest
 */
export type ListTeamInvitationsRequest = Message<"pi_customer_public.ListTeamInvitationsRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;
};

/**
 * Describes the message pi_customer_public.ListTeamInvitationsRequest.
 * Use `create(ListTeamInvitationsRequestSchema)` to create a new message.
 */
export const ListTeamInvitationsRequestSchema: GenMessage<ListTeamInvitationsRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 21);

/**
 * @generated from message pi_customer_public.ListTeamInvitationsResponse
 */
export type ListTeamInvitationsResponse = Message<"pi_customer_public.ListTeamInvitationsResponse"> & {
  /**
   * @generated from field: repeated pi_customer_public.TeamJoinInviteItem invitations = 1;
   */
  invitations: TeamJoinInviteItem[];
};

/**
 * Describes the message pi_customer_public.ListTeamInvitationsResponse.
 * Use `create(ListTeamInvitationsResponseSchema)` to create a new message.
 */
export const ListTeamInvitationsResponseSchema: GenMessage<ListTeamInvitationsResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 22);

/**
 * @generated from message pi_customer_public.TeamJoinInviteItem
 */
export type TeamJoinInviteItem = Message<"pi_customer_public.TeamJoinInviteItem"> & {
  /**
   * @generated from field: string team_join_invite_id = 11;
   */
  teamJoinInviteId: string;

  /**
   * Whether invitation has been accepted
   *
   * @generated from field: bool accepted = 8;
   */
  accepted: boolean;

  /**
   * @generated from field: string email_recipient = 1;
   */
  emailRecipient: string;

  /**
   * @generated from field: string invitee_first_name = 13;
   */
  inviteeFirstName: string;

  /**
   * @generated from field: string invitee_last_name = 14;
   */
  inviteeLastName: string;

  /**
   * @generated from field: string pi_team_id = 3;
   */
  piTeamId: string;

  /**
   * @generated from field: string team_name = 4;
   */
  teamName: string;

  /**
   * @generated from field: wt_srv_shared.Authority authority_to_assign = 15;
   */
  authorityToAssign: Authority;
};

/**
 * Describes the message pi_customer_public.TeamJoinInviteItem.
 * Use `create(TeamJoinInviteItemSchema)` to create a new message.
 */
export const TeamJoinInviteItemSchema: GenMessage<TeamJoinInviteItem> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 23);

/**
 * @generated from message pi_customer_public.InviteUsersRequest
 */
export type InviteUsersRequest = Message<"pi_customer_public.InviteUsersRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: repeated pi_customer_public.TeamJoinInvitee invitees = 2;
   */
  invitees: TeamJoinInvitee[];
};

/**
 * Describes the message pi_customer_public.InviteUsersRequest.
 * Use `create(InviteUsersRequestSchema)` to create a new message.
 */
export const InviteUsersRequestSchema: GenMessage<InviteUsersRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 24);

/**
 * @generated from message pi_customer_public.TeamJoinInvitee
 */
export type TeamJoinInvitee = Message<"pi_customer_public.TeamJoinInvitee"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string first_name = 10;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 11;
   */
  lastName: string;

  /**
   * Optional fields
   *
   * @generated from field: string custom_message = 6;
   */
  customMessage: string;

  /**
   * MEMBER will be assigned if not set
   *
   * @generated from field: wt_srv_shared.Authority authority_to_assign = 7;
   */
  authorityToAssign: Authority;

  /**
   * @generated from field: string industry = 8;
   */
  industry: string;

  /**
   * @generated from field: string organisation = 9;
   */
  organisation: string;
};

/**
 * Describes the message pi_customer_public.TeamJoinInvitee.
 * Use `create(TeamJoinInviteeSchema)` to create a new message.
 */
export const TeamJoinInviteeSchema: GenMessage<TeamJoinInvitee> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 25);

/**
 * @generated from message pi_customer_public.InviteUsersResponse
 */
export type InviteUsersResponse = Message<"pi_customer_public.InviteUsersResponse"> & {
  /**
   * @generated from field: pi_customer_public.InviteUsersStatus status = 1;
   */
  status: InviteUsersStatus;
};

/**
 * Describes the message pi_customer_public.InviteUsersResponse.
 * Use `create(InviteUsersResponseSchema)` to create a new message.
 */
export const InviteUsersResponseSchema: GenMessage<InviteUsersResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 26);

/**
 * @generated from message pi_customer_public.AcceptTeamJoinInviteRequest
 */
export type AcceptTeamJoinInviteRequest = Message<"pi_customer_public.AcceptTeamJoinInviteRequest"> & {
  /**
   * @generated from field: string team_join_invite_id = 1;
   */
  teamJoinInviteId: string;
};

/**
 * Describes the message pi_customer_public.AcceptTeamJoinInviteRequest.
 * Use `create(AcceptTeamJoinInviteRequestSchema)` to create a new message.
 */
export const AcceptTeamJoinInviteRequestSchema: GenMessage<AcceptTeamJoinInviteRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 27);

/**
 * @generated from message pi_customer_public.AcceptTeamJoinInviteResponse
 */
export type AcceptTeamJoinInviteResponse = Message<"pi_customer_public.AcceptTeamJoinInviteResponse"> & {
  /**
   * @generated from field: pi_customer_public.TeamJoinStatus status = 1;
   */
  status: TeamJoinStatus;
};

/**
 * Describes the message pi_customer_public.AcceptTeamJoinInviteResponse.
 * Use `create(AcceptTeamJoinInviteResponseSchema)` to create a new message.
 */
export const AcceptTeamJoinInviteResponseSchema: GenMessage<AcceptTeamJoinInviteResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 28);

/**
 * @generated from message pi_customer_public.ResendInvitationRequest
 */
export type ResendInvitationRequest = Message<"pi_customer_public.ResendInvitationRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message pi_customer_public.ResendInvitationRequest.
 * Use `create(ResendInvitationRequestSchema)` to create a new message.
 */
export const ResendInvitationRequestSchema: GenMessage<ResendInvitationRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 29);

/**
 * @generated from message pi_customer_public.ResendInvitationResponse
 */
export type ResendInvitationResponse = Message<"pi_customer_public.ResendInvitationResponse"> & {
};

/**
 * Describes the message pi_customer_public.ResendInvitationResponse.
 * Use `create(ResendInvitationResponseSchema)` to create a new message.
 */
export const ResendInvitationResponseSchema: GenMessage<ResendInvitationResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 30);

/**
 * @generated from message pi_customer_public.CancelInvitationRequest
 */
export type CancelInvitationRequest = Message<"pi_customer_public.CancelInvitationRequest"> & {
  /**
   * @generated from field: string team_join_invite_id = 1;
   */
  teamJoinInviteId: string;
};

/**
 * Describes the message pi_customer_public.CancelInvitationRequest.
 * Use `create(CancelInvitationRequestSchema)` to create a new message.
 */
export const CancelInvitationRequestSchema: GenMessage<CancelInvitationRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 31);

/**
 * @generated from message pi_customer_public.CancelInvitationResponse
 */
export type CancelInvitationResponse = Message<"pi_customer_public.CancelInvitationResponse"> & {
  /**
   * @generated from field: pi_customer_public.CancelInvitationStatus status = 1;
   */
  status: CancelInvitationStatus;
};

/**
 * Describes the message pi_customer_public.CancelInvitationResponse.
 * Use `create(CancelInvitationResponseSchema)` to create a new message.
 */
export const CancelInvitationResponseSchema: GenMessage<CancelInvitationResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 32);

/**
 * Request ID token is used to identify the current user
 *
 * @generated from message pi_customer_public.SuggestTeamsRequest
 */
export type SuggestTeamsRequest = Message<"pi_customer_public.SuggestTeamsRequest"> & {
};

/**
 * Describes the message pi_customer_public.SuggestTeamsRequest.
 * Use `create(SuggestTeamsRequestSchema)` to create a new message.
 */
export const SuggestTeamsRequestSchema: GenMessage<SuggestTeamsRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 33);

/**
 * @generated from message pi_customer_public.SuggestTeamsResponse
 */
export type SuggestTeamsResponse = Message<"pi_customer_public.SuggestTeamsResponse"> & {
  /**
   * Empty list if none found
   *
   * @generated from field: repeated pi_customer_public.Team teams = 1;
   */
  teams: Team[];
};

/**
 * Describes the message pi_customer_public.SuggestTeamsResponse.
 * Use `create(SuggestTeamsResponseSchema)` to create a new message.
 */
export const SuggestTeamsResponseSchema: GenMessage<SuggestTeamsResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 34);

/**
 * @generated from message pi_customer_public.RequestToJoinTeamRequest
 */
export type RequestToJoinTeamRequest = Message<"pi_customer_public.RequestToJoinTeamRequest"> & {
  /**
   * Request ID token is used to identify the current user
   *
   * @generated from field: repeated string team_id = 1;
   */
  teamId: string[];
};

/**
 * Describes the message pi_customer_public.RequestToJoinTeamRequest.
 * Use `create(RequestToJoinTeamRequestSchema)` to create a new message.
 */
export const RequestToJoinTeamRequestSchema: GenMessage<RequestToJoinTeamRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 35);

/**
 * @generated from message pi_customer_public.RequestToJoinTeamResponse
 */
export type RequestToJoinTeamResponse = Message<"pi_customer_public.RequestToJoinTeamResponse"> & {
  /**
   * @generated from field: repeated pi_customer_public.RequestToJoinTeamResult result = 1;
   */
  result: RequestToJoinTeamResult[];
};

/**
 * Describes the message pi_customer_public.RequestToJoinTeamResponse.
 * Use `create(RequestToJoinTeamResponseSchema)` to create a new message.
 */
export const RequestToJoinTeamResponseSchema: GenMessage<RequestToJoinTeamResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 36);

/**
 * @generated from message pi_customer_public.RequestToJoinTeamResult
 */
export type RequestToJoinTeamResult = Message<"pi_customer_public.RequestToJoinTeamResult"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: pi_customer_public.RequestToJoinTeamStatus status = 2;
   */
  status: RequestToJoinTeamStatus;
};

/**
 * Describes the message pi_customer_public.RequestToJoinTeamResult.
 * Use `create(RequestToJoinTeamResultSchema)` to create a new message.
 */
export const RequestToJoinTeamResultSchema: GenMessage<RequestToJoinTeamResult> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 37);

/**
 * Request ID token is used to identify the current user
 *
 * @generated from message pi_customer_public.ListMyPendingTeamJoinRequestsRequest
 */
export type ListMyPendingTeamJoinRequestsRequest = Message<"pi_customer_public.ListMyPendingTeamJoinRequestsRequest"> & {
};

/**
 * Describes the message pi_customer_public.ListMyPendingTeamJoinRequestsRequest.
 * Use `create(ListMyPendingTeamJoinRequestsRequestSchema)` to create a new message.
 */
export const ListMyPendingTeamJoinRequestsRequestSchema: GenMessage<ListMyPendingTeamJoinRequestsRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 38);

/**
 * @generated from message pi_customer_public.ListMyPendingTeamJoinRequestsResponse
 */
export type ListMyPendingTeamJoinRequestsResponse = Message<"pi_customer_public.ListMyPendingTeamJoinRequestsResponse"> & {
  /**
   * @generated from field: repeated pi_customer_public.TeamJoinRequestRecord pending_team_join_requests = 1;
   */
  pendingTeamJoinRequests: TeamJoinRequestRecord[];
};

/**
 * Describes the message pi_customer_public.ListMyPendingTeamJoinRequestsResponse.
 * Use `create(ListMyPendingTeamJoinRequestsResponseSchema)` to create a new message.
 */
export const ListMyPendingTeamJoinRequestsResponseSchema: GenMessage<ListMyPendingTeamJoinRequestsResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 39);

/**
 * @generated from message pi_customer_public.ResendRequestToJoinTeamRequest
 */
export type ResendRequestToJoinTeamRequest = Message<"pi_customer_public.ResendRequestToJoinTeamRequest"> & {
  /**
   * @generated from field: string team_join_request_id = 1;
   */
  teamJoinRequestId: string;
};

/**
 * Describes the message pi_customer_public.ResendRequestToJoinTeamRequest.
 * Use `create(ResendRequestToJoinTeamRequestSchema)` to create a new message.
 */
export const ResendRequestToJoinTeamRequestSchema: GenMessage<ResendRequestToJoinTeamRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 40);

/**
 * @generated from message pi_customer_public.ResendRequestToJoinTeamResponse
 */
export type ResendRequestToJoinTeamResponse = Message<"pi_customer_public.ResendRequestToJoinTeamResponse"> & {
  /**
   * @generated from field: pi_customer_public.ResendRequestToJoinStatus status = 1;
   */
  status: ResendRequestToJoinStatus;
};

/**
 * Describes the message pi_customer_public.ResendRequestToJoinTeamResponse.
 * Use `create(ResendRequestToJoinTeamResponseSchema)` to create a new message.
 */
export const ResendRequestToJoinTeamResponseSchema: GenMessage<ResendRequestToJoinTeamResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 41);

/**
 * @generated from message pi_customer_public.TeamJoinRequestRecord
 */
export type TeamJoinRequestRecord = Message<"pi_customer_public.TeamJoinRequestRecord"> & {
  /**
   * @generated from field: string team_join_request_id = 1;
   */
  teamJoinRequestId: string;

  /**
   * @generated from field: pi_customer_public.Team team = 2;
   */
  team?: Team;

  /**
   * @generated from field: pi_customer_public.TeamJoinUserInfo user = 3;
   */
  user?: TeamJoinUserInfo;

  /**
   * When the request was recorded, as number of seconds since epoch
   *
   * @generated from field: uint64 timestamp = 4;
   */
  timestamp: bigint;
};

/**
 * Describes the message pi_customer_public.TeamJoinRequestRecord.
 * Use `create(TeamJoinRequestRecordSchema)` to create a new message.
 */
export const TeamJoinRequestRecordSchema: GenMessage<TeamJoinRequestRecord> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 42);

/**
 * @generated from message pi_customer_public.TeamJoinUserInfo
 */
export type TeamJoinUserInfo = Message<"pi_customer_public.TeamJoinUserInfo"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string first_name = 2;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 3;
   */
  lastName: string;

  /**
   * @generated from field: string email = 5;
   */
  email: string;

  /**
   * @generated from field: string country = 6;
   */
  country: string;

  /**
   * @generated from field: string timezone = 11;
   */
  timezone: string;

  /**
   * Data retention set by user, can be MAX_ELIGIBLE.
   *
   * @generated from field: wisetime.type.DataRetentionPeriod data_retention_period = 13;
   */
  dataRetentionPeriod: DataRetentionPeriod;

  /**
   * Maximum data retention period available to the user.
   *
   * @generated from field: wisetime.type.DataRetentionPeriod resolved_data_retention_period = 15;
   */
  resolvedDataRetentionPeriod: DataRetentionPeriod;

  /**
   * Optional fields;
   *
   * @generated from field: string phone = 7;
   */
  phone: string;

  /**
   * @generated from field: string state = 8;
   */
  state: string;

  /**
   * @generated from field: string address = 9;
   */
  address: string;

  /**
   * @generated from field: string zip_code = 10;
   */
  zipCode: string;

  /**
   * @generated from field: repeated wt_srv_shared.ManagementSystemType management_system_types = 18;
   */
  managementSystemTypes: ManagementSystemType[];

  /**
   * @generated from field: string user_photo_url = 19;
   */
  userPhotoUrl: string;
};

/**
 * Describes the message pi_customer_public.TeamJoinUserInfo.
 * Use `create(TeamJoinUserInfoSchema)` to create a new message.
 */
export const TeamJoinUserInfoSchema: GenMessage<TeamJoinUserInfo> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 43);

/**
 * Needs to have few fields because this is sent via UserContext/ID token
 *
 * @generated from message pi_customer_public.Team
 */
export type Team = Message<"pi_customer_public.Team"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message pi_customer_public.Team.
 * Use `create(TeamSchema)` to create a new message.
 */
export const TeamSchema: GenMessage<Team> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 44);

/**
 * @generated from message pi_customer_public.CancelMyRequestToJoinTeamRequest
 */
export type CancelMyRequestToJoinTeamRequest = Message<"pi_customer_public.CancelMyRequestToJoinTeamRequest"> & {
  /**
   * @generated from field: string team_join_request_id = 1;
   */
  teamJoinRequestId: string;
};

/**
 * Describes the message pi_customer_public.CancelMyRequestToJoinTeamRequest.
 * Use `create(CancelMyRequestToJoinTeamRequestSchema)` to create a new message.
 */
export const CancelMyRequestToJoinTeamRequestSchema: GenMessage<CancelMyRequestToJoinTeamRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 45);

/**
 * @generated from message pi_customer_public.CancelMyRequestToJoinTeamResponse
 */
export type CancelMyRequestToJoinTeamResponse = Message<"pi_customer_public.CancelMyRequestToJoinTeamResponse"> & {
  /**
   * @generated from field: pi_customer_public.CancelMyRequestToJoinTeamStatus status = 1;
   */
  status: CancelMyRequestToJoinTeamStatus;
};

/**
 * Describes the message pi_customer_public.CancelMyRequestToJoinTeamResponse.
 * Use `create(CancelMyRequestToJoinTeamResponseSchema)` to create a new message.
 */
export const CancelMyRequestToJoinTeamResponseSchema: GenMessage<CancelMyRequestToJoinTeamResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 46);

/**
 * @generated from message pi_customer_public.ListTeamJoinRequestsRequest
 */
export type ListTeamJoinRequestsRequest = Message<"pi_customer_public.ListTeamJoinRequestsRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;
};

/**
 * Describes the message pi_customer_public.ListTeamJoinRequestsRequest.
 * Use `create(ListTeamJoinRequestsRequestSchema)` to create a new message.
 */
export const ListTeamJoinRequestsRequestSchema: GenMessage<ListTeamJoinRequestsRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 47);

/**
 * @generated from message pi_customer_public.ListTeamJoinRequestsResponse
 */
export type ListTeamJoinRequestsResponse = Message<"pi_customer_public.ListTeamJoinRequestsResponse"> & {
  /**
   * @generated from field: repeated pi_customer_public.TeamJoinRequestRecord team_join_requests = 1;
   */
  teamJoinRequests: TeamJoinRequestRecord[];
};

/**
 * Describes the message pi_customer_public.ListTeamJoinRequestsResponse.
 * Use `create(ListTeamJoinRequestsResponseSchema)` to create a new message.
 */
export const ListTeamJoinRequestsResponseSchema: GenMessage<ListTeamJoinRequestsResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 48);

/**
 * @generated from message pi_customer_public.ApproveRequestToJoinTeamRequest
 */
export type ApproveRequestToJoinTeamRequest = Message<"pi_customer_public.ApproveRequestToJoinTeamRequest"> & {
  /**
   * @generated from field: string team_join_request_id = 1;
   */
  teamJoinRequestId: string;

  /**
   * @generated from field: wt_srv_shared.Authority authority_to_assign = 2;
   */
  authorityToAssign: Authority;
};

/**
 * Describes the message pi_customer_public.ApproveRequestToJoinTeamRequest.
 * Use `create(ApproveRequestToJoinTeamRequestSchema)` to create a new message.
 */
export const ApproveRequestToJoinTeamRequestSchema: GenMessage<ApproveRequestToJoinTeamRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 49);

/**
 * @generated from message pi_customer_public.ApproveRequestToJoinTeamResponse
 */
export type ApproveRequestToJoinTeamResponse = Message<"pi_customer_public.ApproveRequestToJoinTeamResponse"> & {
  /**
   * @generated from field: pi_customer_public.ApproveRequestToJoinTeamStatus status = 1;
   */
  status: ApproveRequestToJoinTeamStatus;
};

/**
 * Describes the message pi_customer_public.ApproveRequestToJoinTeamResponse.
 * Use `create(ApproveRequestToJoinTeamResponseSchema)` to create a new message.
 */
export const ApproveRequestToJoinTeamResponseSchema: GenMessage<ApproveRequestToJoinTeamResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 50);

/**
 * @generated from message pi_customer_public.DeclineRequestToJoinTeamRequest
 */
export type DeclineRequestToJoinTeamRequest = Message<"pi_customer_public.DeclineRequestToJoinTeamRequest"> & {
  /**
   * @generated from field: string team_join_request_id = 1;
   */
  teamJoinRequestId: string;

  /**
   * optional
   *
   * @generated from field: string decline_message = 2;
   */
  declineMessage: string;
};

/**
 * Describes the message pi_customer_public.DeclineRequestToJoinTeamRequest.
 * Use `create(DeclineRequestToJoinTeamRequestSchema)` to create a new message.
 */
export const DeclineRequestToJoinTeamRequestSchema: GenMessage<DeclineRequestToJoinTeamRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 51);

/**
 * @generated from message pi_customer_public.DeclineRequestToJoinTeamResponse
 */
export type DeclineRequestToJoinTeamResponse = Message<"pi_customer_public.DeclineRequestToJoinTeamResponse"> & {
  /**
   * @generated from field: pi_customer_public.DeclineRequestToJoinTeamStatus status = 1;
   */
  status: DeclineRequestToJoinTeamStatus;
};

/**
 * Describes the message pi_customer_public.DeclineRequestToJoinTeamResponse.
 * Use `create(DeclineRequestToJoinTeamResponseSchema)` to create a new message.
 */
export const DeclineRequestToJoinTeamResponseSchema: GenMessage<DeclineRequestToJoinTeamResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 52);

/**
 * @generated from message pi_customer_public.ListTeamMembershipsRequest
 */
export type ListTeamMembershipsRequest = Message<"pi_customer_public.ListTeamMembershipsRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;
};

/**
 * Describes the message pi_customer_public.ListTeamMembershipsRequest.
 * Use `create(ListTeamMembershipsRequestSchema)` to create a new message.
 */
export const ListTeamMembershipsRequestSchema: GenMessage<ListTeamMembershipsRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 53);

/**
 * @generated from message pi_customer_public.ListTeamMembershipsResponse
 */
export type ListTeamMembershipsResponse = Message<"pi_customer_public.ListTeamMembershipsResponse"> & {
  /**
   * @generated from field: repeated pi_customer_public.Membership memberships = 1;
   */
  memberships: Membership[];
};

/**
 * Describes the message pi_customer_public.ListTeamMembershipsResponse.
 * Use `create(ListTeamMembershipsResponseSchema)` to create a new message.
 */
export const ListTeamMembershipsResponseSchema: GenMessage<ListTeamMembershipsResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 54);

/**
 * @generated from message pi_customer_public.Membership
 */
export type Membership = Message<"pi_customer_public.Membership"> & {
  /**
   * @generated from field: string membership_id = 1;
   */
  membershipId: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: wt_srv_shared.Authority authority = 4;
   */
  authority: Authority;

  /**
   * @generated from field: pi_customer_public.MembershipStatus membership_status = 5;
   */
  membershipStatus: MembershipStatus;

  /**
   * @generated from field: pi_customer_public.BusinessRole business_role = 7;
   */
  businessRole?: BusinessRole;

  /**
   * 0 - 100. Expect an unsigned integer.
   *
   * @generated from field: float experience_weighting_percent = 8;
   */
  experienceWeightingPercent: number;

  /**
   * @generated from field: string external_user_id = 9;
   */
  externalUserId: string;

  /**
   * @generated from field: string email = 10;
   */
  email: string;

  /**
   * @generated from field: string first_name = 11;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 12;
   */
  lastName: string;

  /**
   * @generated from field: string user_photo_url = 13;
   */
  userPhotoUrl: string;

  /**
   * @generated from field: bool anonymization_requested = 14;
   */
  anonymizationRequested: boolean;
};

/**
 * Describes the message pi_customer_public.Membership.
 * Use `create(MembershipSchema)` to create a new message.
 */
export const MembershipSchema: GenMessage<Membership> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 55);

/**
 * @generated from message pi_customer_public.BusinessRole
 */
export type BusinessRole = Message<"pi_customer_public.BusinessRole"> & {
  /**
   * @generated from field: string business_role_id = 1;
   */
  businessRoleId: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message pi_customer_public.BusinessRole.
 * Use `create(BusinessRoleSchema)` to create a new message.
 */
export const BusinessRoleSchema: GenMessage<BusinessRole> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 56);

/**
 * @generated from message pi_customer_public.UpdateTeamMembershipRequest
 */
export type UpdateTeamMembershipRequest = Message<"pi_customer_public.UpdateTeamMembershipRequest"> & {
  /**
   * @generated from field: string membership_id = 1;
   */
  membershipId: string;

  /**
   * @generated from field: pi_customer_public.MembershipStatus membership_status = 5;
   */
  membershipStatus: MembershipStatus;

  /**
   * @generated from field: string business_role_id = 6;
   */
  businessRoleId: string;

  /**
   * Valid between 0 and 100 inclusive
   *
   * @generated from field: uint32 experience_weighting_percent = 7;
   */
  experienceWeightingPercent: number;

  /**
   * @generated from field: string external_user_id = 8;
   */
  externalUserId: string;
};

/**
 * Describes the message pi_customer_public.UpdateTeamMembershipRequest.
 * Use `create(UpdateTeamMembershipRequestSchema)` to create a new message.
 */
export const UpdateTeamMembershipRequestSchema: GenMessage<UpdateTeamMembershipRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 57);

/**
 * @generated from message pi_customer_public.UpdateTeamMembershipResponse
 */
export type UpdateTeamMembershipResponse = Message<"pi_customer_public.UpdateTeamMembershipResponse"> & {
};

/**
 * Describes the message pi_customer_public.UpdateTeamMembershipResponse.
 * Use `create(UpdateTeamMembershipResponseSchema)` to create a new message.
 */
export const UpdateTeamMembershipResponseSchema: GenMessage<UpdateTeamMembershipResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 58);

/**
 * @generated from message pi_customer_public.CancelMembershipRequest
 */
export type CancelMembershipRequest = Message<"pi_customer_public.CancelMembershipRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message pi_customer_public.CancelMembershipRequest.
 * Use `create(CancelMembershipRequestSchema)` to create a new message.
 */
export const CancelMembershipRequestSchema: GenMessage<CancelMembershipRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 59);

/**
 * @generated from message pi_customer_public.CancelMembershipResponse
 */
export type CancelMembershipResponse = Message<"pi_customer_public.CancelMembershipResponse"> & {
  /**
   * @generated from field: pi_customer_public.CancelMembershipStatus status = 1;
   */
  status: CancelMembershipStatus;
};

/**
 * Describes the message pi_customer_public.CancelMembershipResponse.
 * Use `create(CancelMembershipResponseSchema)` to create a new message.
 */
export const CancelMembershipResponseSchema: GenMessage<CancelMembershipResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 60);

/**
 * @generated from message pi_customer_public.ActivateMembershipRequest
 */
export type ActivateMembershipRequest = Message<"pi_customer_public.ActivateMembershipRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message pi_customer_public.ActivateMembershipRequest.
 * Use `create(ActivateMembershipRequestSchema)` to create a new message.
 */
export const ActivateMembershipRequestSchema: GenMessage<ActivateMembershipRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 61);

/**
 * @generated from message pi_customer_public.ActivateMembershipResponse
 */
export type ActivateMembershipResponse = Message<"pi_customer_public.ActivateMembershipResponse"> & {
  /**
   * @generated from field: pi_customer_public.ActivateMembershipStatus status = 1;
   */
  status: ActivateMembershipStatus;
};

/**
 * Describes the message pi_customer_public.ActivateMembershipResponse.
 * Use `create(ActivateMembershipResponseSchema)` to create a new message.
 */
export const ActivateMembershipResponseSchema: GenMessage<ActivateMembershipResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 62);

/**
 * @generated from message pi_customer_public.ForgetTeamMemberRequest
 */
export type ForgetTeamMemberRequest = Message<"pi_customer_public.ForgetTeamMemberRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message pi_customer_public.ForgetTeamMemberRequest.
 * Use `create(ForgetTeamMemberRequestSchema)` to create a new message.
 */
export const ForgetTeamMemberRequestSchema: GenMessage<ForgetTeamMemberRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 63);

/**
 * @generated from message pi_customer_public.ForgetTeamMemberResponse
 */
export type ForgetTeamMemberResponse = Message<"pi_customer_public.ForgetTeamMemberResponse"> & {
  /**
   * @generated from field: pi_customer_public.ForgetTeamMemberStatus status = 1;
   */
  status: ForgetTeamMemberStatus;
};

/**
 * Describes the message pi_customer_public.ForgetTeamMemberResponse.
 * Use `create(ForgetTeamMemberResponseSchema)` to create a new message.
 */
export const ForgetTeamMemberResponseSchema: GenMessage<ForgetTeamMemberResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 64);

/**
 * @generated from message pi_customer_public.InvokeRightToBeForgottenRequest
 */
export type InvokeRightToBeForgottenRequest = Message<"pi_customer_public.InvokeRightToBeForgottenRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;
};

/**
 * Describes the message pi_customer_public.InvokeRightToBeForgottenRequest.
 * Use `create(InvokeRightToBeForgottenRequestSchema)` to create a new message.
 */
export const InvokeRightToBeForgottenRequestSchema: GenMessage<InvokeRightToBeForgottenRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 65);

/**
 * @generated from message pi_customer_public.InvokeRightToBeForgottenResponse
 */
export type InvokeRightToBeForgottenResponse = Message<"pi_customer_public.InvokeRightToBeForgottenResponse"> & {
  /**
   * @generated from field: pi_customer_public.ForgottenStatus status = 1;
   */
  status: ForgottenStatus;
};

/**
 * Describes the message pi_customer_public.InvokeRightToBeForgottenResponse.
 * Use `create(InvokeRightToBeForgottenResponseSchema)` to create a new message.
 */
export const InvokeRightToBeForgottenResponseSchema: GenMessage<InvokeRightToBeForgottenResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 66);

/**
 * @generated from message pi_customer_public.UpdateAuthorityRequest
 */
export type UpdateAuthorityRequest = Message<"pi_customer_public.UpdateAuthorityRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: wt_srv_shared.Authority authority = 3;
   */
  authority: Authority;
};

/**
 * Describes the message pi_customer_public.UpdateAuthorityRequest.
 * Use `create(UpdateAuthorityRequestSchema)` to create a new message.
 */
export const UpdateAuthorityRequestSchema: GenMessage<UpdateAuthorityRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 67);

/**
 * @generated from message pi_customer_public.UpdateAuthorityResponse
 */
export type UpdateAuthorityResponse = Message<"pi_customer_public.UpdateAuthorityResponse"> & {
  /**
   * error message when update is not possible
   *
   * @generated from field: pi_customer_public.UpdateAuthorityStatus status = 1;
   */
  status: UpdateAuthorityStatus;
};

/**
 * Describes the message pi_customer_public.UpdateAuthorityResponse.
 * Use `create(UpdateAuthorityResponseSchema)` to create a new message.
 */
export const UpdateAuthorityResponseSchema: GenMessage<UpdateAuthorityResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 68);

/**
 * @generated from message pi_customer_public.ListBusinessRolesRequest
 */
export type ListBusinessRolesRequest = Message<"pi_customer_public.ListBusinessRolesRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;
};

/**
 * Describes the message pi_customer_public.ListBusinessRolesRequest.
 * Use `create(ListBusinessRolesRequestSchema)` to create a new message.
 */
export const ListBusinessRolesRequestSchema: GenMessage<ListBusinessRolesRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 69);

/**
 * @generated from message pi_customer_public.ListBusinessRolesResponse
 */
export type ListBusinessRolesResponse = Message<"pi_customer_public.ListBusinessRolesResponse"> & {
  /**
   * @generated from field: repeated pi_customer_public.BusinessRole business_roles = 1;
   */
  businessRoles: BusinessRole[];
};

/**
 * Describes the message pi_customer_public.ListBusinessRolesResponse.
 * Use `create(ListBusinessRolesResponseSchema)` to create a new message.
 */
export const ListBusinessRolesResponseSchema: GenMessage<ListBusinessRolesResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 70);

/**
 * @generated from message pi_customer_public.CreateBusinessRoleRequest
 */
export type CreateBusinessRoleRequest = Message<"pi_customer_public.CreateBusinessRoleRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message pi_customer_public.CreateBusinessRoleRequest.
 * Use `create(CreateBusinessRoleRequestSchema)` to create a new message.
 */
export const CreateBusinessRoleRequestSchema: GenMessage<CreateBusinessRoleRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 71);

/**
 * @generated from message pi_customer_public.CreateBusinessRoleResponse
 */
export type CreateBusinessRoleResponse = Message<"pi_customer_public.CreateBusinessRoleResponse"> & {
};

/**
 * Describes the message pi_customer_public.CreateBusinessRoleResponse.
 * Use `create(CreateBusinessRoleResponseSchema)` to create a new message.
 */
export const CreateBusinessRoleResponseSchema: GenMessage<CreateBusinessRoleResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 72);

/**
 * @generated from message pi_customer_public.UpdateBusinessRoleRequest
 */
export type UpdateBusinessRoleRequest = Message<"pi_customer_public.UpdateBusinessRoleRequest"> & {
  /**
   * @generated from field: string business_role_id = 1;
   */
  businessRoleId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message pi_customer_public.UpdateBusinessRoleRequest.
 * Use `create(UpdateBusinessRoleRequestSchema)` to create a new message.
 */
export const UpdateBusinessRoleRequestSchema: GenMessage<UpdateBusinessRoleRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 73);

/**
 * @generated from message pi_customer_public.UpdateBusinessRoleResponse
 */
export type UpdateBusinessRoleResponse = Message<"pi_customer_public.UpdateBusinessRoleResponse"> & {
};

/**
 * Describes the message pi_customer_public.UpdateBusinessRoleResponse.
 * Use `create(UpdateBusinessRoleResponseSchema)` to create a new message.
 */
export const UpdateBusinessRoleResponseSchema: GenMessage<UpdateBusinessRoleResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 74);

/**
 * @generated from message pi_customer_public.DeleteBusinessRoleRequest
 */
export type DeleteBusinessRoleRequest = Message<"pi_customer_public.DeleteBusinessRoleRequest"> & {
  /**
   * @generated from field: string business_role_id = 1;
   */
  businessRoleId: string;
};

/**
 * Describes the message pi_customer_public.DeleteBusinessRoleRequest.
 * Use `create(DeleteBusinessRoleRequestSchema)` to create a new message.
 */
export const DeleteBusinessRoleRequestSchema: GenMessage<DeleteBusinessRoleRequest> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 75);

/**
 * @generated from message pi_customer_public.DeleteBusinessRoleResponse
 */
export type DeleteBusinessRoleResponse = Message<"pi_customer_public.DeleteBusinessRoleResponse"> & {
};

/**
 * Describes the message pi_customer_public.DeleteBusinessRoleResponse.
 * Use `create(DeleteBusinessRoleResponseSchema)` to create a new message.
 */
export const DeleteBusinessRoleResponseSchema: GenMessage<DeleteBusinessRoleResponse> = /*@__PURE__*/
  messageDesc(file_wt_svc_customer_user_team, 76);

/**
 * @generated from enum pi_customer_public.CreateTeamStatus
 */
export enum CreateTeamStatus {
  /**
   * @generated from enum value: CREATE_TEAM_STATUS_UNSPECIFIED = 0;
   */
  CREATE_TEAM_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: CREATE_TEAM_SUCCESS = 1;
   */
  CREATE_TEAM_SUCCESS = 1,

  /**
   * E.g. team name empty
   *
   * @generated from enum value: CANT_CREATE_TEAM_INVALID_REQUEST = 2;
   */
  CANT_CREATE_TEAM_INVALID_REQUEST = 2,

  /**
   * @generated from enum value: CANT_CREATE_TEAM_ALREADY_EXISTS_IN_ORGANIZATION = 3;
   */
  CANT_CREATE_TEAM_ALREADY_EXISTS_IN_ORGANIZATION = 3,

  /**
   * @generated from enum value: CANT_CREATE_TEAM_INTERNAL_ERROR = 4;
   */
  CANT_CREATE_TEAM_INTERNAL_ERROR = 4,

  /**
   * @generated from enum value: CANT_CREATE_TEAM_STARTER_TEAM_LIMIT_REACHED = 5 [deprecated = true];
   * @deprecated
   */
  CANT_CREATE_TEAM_STARTER_TEAM_LIMIT_REACHED = 5,

  /**
   * @generated from enum value: CANT_CREATE_TEAM_TEAM_LIMIT_REACHED = 6;
   */
  CANT_CREATE_TEAM_TEAM_LIMIT_REACHED = 6,
}

/**
 * Describes the enum pi_customer_public.CreateTeamStatus.
 */
export const CreateTeamStatusSchema: GenEnum<CreateTeamStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 0);

/**
 * *
 * Determines behaviour of `Include details from following time entries` in grouping pane,
 * and supplied when posting time rows without a group.
 * The UI would be better named as `Include detailed information of time rows`.
 *
 * @generated from enum pi_customer_public.IncludeActivityDefault
 */
export enum IncludeActivityDefault {
  /**
   * expected behaviour if boundary condition reached is to log warning and assume value as ENABLED
   *
   * @generated from enum value: INCLUDE_DETAIL_UNKNOWN = 0;
   */
  INCLUDE_DETAIL_UNKNOWN = 0,

  /**
   * the `Include detailed information of time rows` in the group time dialog is set to default of checked,
   * and the value that should be provided when posting time without a group.
   *
   * @generated from enum value: INCLUDE_DETAIL_ENABLED = 1;
   */
  INCLUDE_DETAIL_ENABLED = 1,

  /**
   * the `Include detailed information of time rows` in the group time dialog is set to default of *un*checked,
   * and the value that should be provided when posting time without a group.
   *
   * @generated from enum value: INCLUDE_DETAIL_DISABLED = 2;
   */
  INCLUDE_DETAIL_DISABLED = 2,
}

/**
 * Describes the enum pi_customer_public.IncludeActivityDefault.
 */
export const IncludeActivityDefaultSchema: GenEnum<IncludeActivityDefault> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 1);

/**
 * @generated from enum pi_customer_public.UpdateTeamStatus
 */
export enum UpdateTeamStatus {
  /**
   * @generated from enum value: UPDATE_TEAM_UNSPECIFIED = 0;
   */
  UPDATE_TEAM_UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPDATE_TEAM_SUCCESS = 1;
   */
  UPDATE_TEAM_SUCCESS = 1,

  /**
   * team with such id not found
   *
   * @generated from enum value: CANT_UPDATE_TEAM_NOT_FOUND = 2;
   */
  CANT_UPDATE_TEAM_NOT_FOUND = 2,

  /**
   * team with such name already exists in organisation
   *
   * @generated from enum value: CANT_UPDATE_TEAM_ALREADY_EXISTS = 3;
   */
  CANT_UPDATE_TEAM_ALREADY_EXISTS = 3,

  /**
   * @generated from enum value: CANT_UPDATE_TEAM_INVALID_RETENTION = 4;
   */
  CANT_UPDATE_TEAM_INVALID_RETENTION = 4,
}

/**
 * Describes the enum pi_customer_public.UpdateTeamStatus.
 */
export const UpdateTeamStatusSchema: GenEnum<UpdateTeamStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 2);

/**
 * @generated from enum pi_customer_public.UpdateTeamNameStatus
 */
export enum UpdateTeamNameStatus {
  /**
   * @generated from enum value: UPDATE_TEAM_NAME_UNSPECIFIED = 0;
   */
  UPDATE_TEAM_NAME_UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPDATE_TEAM_NAME_SUCCESS = 1;
   */
  UPDATE_TEAM_NAME_SUCCESS = 1,

  /**
   * team with such id not found
   *
   * @generated from enum value: CANT_UPDATE_TEAM_NAME_NOT_FOUND = 2;
   */
  CANT_UPDATE_TEAM_NAME_NOT_FOUND = 2,

  /**
   * team with such name already exists in organisation
   *
   * @generated from enum value: CANT_UPDATE_TEAM_NAME_ALREADY_EXISTS = 3;
   */
  CANT_UPDATE_TEAM_NAME_ALREADY_EXISTS = 3,
}

/**
 * Describes the enum pi_customer_public.UpdateTeamNameStatus.
 */
export const UpdateTeamNameStatusSchema: GenEnum<UpdateTeamNameStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 3);

/**
 * @generated from enum pi_customer_public.TeamDeleteReason
 */
export enum TeamDeleteReason {
  /**
   * @generated from enum value: TEAM_DELETE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEAM_DELETE_REASON_LACKED_FEATURES = 1;
   */
  LACKED_FEATURES = 1,

  /**
   * @generated from enum value: TEAM_DELETE_REASON_TOO_COSTLY = 2;
   */
  TOO_COSTLY = 2,

  /**
   * @generated from enum value: TEAM_DELETE_REASON_NO_SUPPORT = 3;
   */
  NO_SUPPORT = 3,

  /**
   * @generated from enum value: TEAM_DELETE_REASON_SUBSTITUTE_PRODUCT = 4;
   */
  SUBSTITUTE_PRODUCT = 4,

  /**
   * @generated from enum value: TEAM_DELETE_REASON_OTHER_REASON = 5;
   */
  OTHER_REASON = 5,

  /**
   * @generated from enum value: TEAM_DELETE_REASON_INTEGRATION_NOT_SUPPORTED = 6;
   */
  INTEGRATION_NOT_SUPPORTED = 6,
}

/**
 * Describes the enum pi_customer_public.TeamDeleteReason.
 */
export const TeamDeleteReasonSchema: GenEnum<TeamDeleteReason> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 4);

/**
 * @generated from enum pi_customer_public.InviteUsersStatus
 */
export enum InviteUsersStatus {
  /**
   * @generated from enum value: INVITE_USERS_STATUS_UNSPECIFIED = 0;
   */
  INVITE_USERS_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: INVITE_USERS_SUCCESS = 1;
   */
  INVITE_USERS_SUCCESS = 1,

  /**
   * @generated from enum value: CANT_INVITE_USERS_MAX_MEMBERS_EXCEEDED = 2;
   */
  CANT_INVITE_USERS_MAX_MEMBERS_EXCEEDED = 2,

  /**
   * requestor authority not higher than MEMBER
   *
   * @generated from enum value: CANT_INVITE_USERS_PERMISSION_DENIED = 3;
   */
  CANT_INVITE_USERS_PERMISSION_DENIED = 3,

  /**
   * @generated from enum value: CANT_INVITE_USERS_TEAM_NOT_FOUND = 4;
   */
  CANT_INVITE_USERS_TEAM_NOT_FOUND = 4,
}

/**
 * Describes the enum pi_customer_public.InviteUsersStatus.
 */
export const InviteUsersStatusSchema: GenEnum<InviteUsersStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 5);

/**
 * @generated from enum pi_customer_public.TeamJoinStatus
 */
export enum TeamJoinStatus {
  /**
   * @generated from enum value: INVALID_INVITE_ID = 0;
   */
  INVALID_INVITE_ID = 0,

  /**
   * @generated from enum value: ALREADY_JOINED = 1;
   */
  ALREADY_JOINED = 1,

  /**
   * @generated from enum value: JOIN_SUCCESS = 2;
   */
  JOIN_SUCCESS = 2,

  /**
   * @generated from enum value: CANT_JOIN_TEAM_USER_NOT_FOUND = 3;
   */
  CANT_JOIN_TEAM_USER_NOT_FOUND = 3,

  /**
   * @generated from enum value: CANT_JOIN_TEAM_INVITE_NOT_FOUND = 4;
   */
  CANT_JOIN_TEAM_INVITE_NOT_FOUND = 4,

  /**
   * @generated from enum value: CANT_JOIN_TEAM_INVITE_DETAILS_NOT_FOUND = 5;
   */
  CANT_JOIN_TEAM_INVITE_DETAILS_NOT_FOUND = 5,

  /**
   * @generated from enum value: CANT_JOIN_TEAM_NOT_AVAILABLE = 6;
   */
  CANT_JOIN_TEAM_NOT_AVAILABLE = 6,
}

/**
 * Describes the enum pi_customer_public.TeamJoinStatus.
 */
export const TeamJoinStatusSchema: GenEnum<TeamJoinStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 6);

/**
 * @generated from enum pi_customer_public.CancelInvitationStatus
 */
export enum CancelInvitationStatus {
  /**
   * @generated from enum value: CANCEL_STATUS_UNSPECIFIED = 0;
   */
  CANCEL_STATUS_UNSPECIFIED = 0,

  /**
   * invitation has been cancelled
   *
   * @generated from enum value: CANCEL_STATUS_SUCCESS = 1;
   */
  CANCEL_STATUS_SUCCESS = 1,

  /**
   * @generated from enum value: CANCEL_STATUS_INVITATION_NOT_FOUND = 2;
   */
  CANCEL_STATUS_INVITATION_NOT_FOUND = 2,

  /**
   * security error, insufficient permission
   *
   * @generated from enum value: CANCEL_STATUS_PERMISSION_DENIED = 3;
   */
  CANCEL_STATUS_PERMISSION_DENIED = 3,

  /**
   * can't cancel already accepted invitation
   *
   * @generated from enum value: CANCEL_STATUS_ALREADY_ACCEPTED = 4;
   */
  CANCEL_STATUS_ALREADY_ACCEPTED = 4,

  /**
   * Internal/unknown service error
   *
   * @generated from enum value: CANCEL_STATUS_INTERNAL_ERROR = 5;
   */
  CANCEL_STATUS_INTERNAL_ERROR = 5,
}

/**
 * Describes the enum pi_customer_public.CancelInvitationStatus.
 */
export const CancelInvitationStatusSchema: GenEnum<CancelInvitationStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 7);

/**
 * @generated from enum pi_customer_public.RequestToJoinTeamStatus
 */
export enum RequestToJoinTeamStatus {
  /**
   * @generated from enum value: REQUEST_TO_JOIN_TEAM_STATUS_UNSPECIFIED = 0;
   */
  REQUEST_TO_JOIN_TEAM_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: REQUEST_SENT_SUCCESS = 1;
   */
  REQUEST_SENT_SUCCESS = 1,

  /**
   * @generated from enum value: CANT_REQUEST_TO_JOIN_TEAM_NOT_FOUND = 2;
   */
  CANT_REQUEST_TO_JOIN_TEAM_NOT_FOUND = 2,

  /**
   * @generated from enum value: CANT_REQUEST_TO_JOIN_TEAM_ALREADY_A_MEMBER = 3;
   */
  CANT_REQUEST_TO_JOIN_TEAM_ALREADY_A_MEMBER = 3,

  /**
   * @generated from enum value: CANT_REQUEST_TO_JOIN_TEAM_ALREADY_REQUESTED = 4;
   */
  CANT_REQUEST_TO_JOIN_TEAM_ALREADY_REQUESTED = 4,

  /**
   * user's email is not matching requested team's domain
   *
   * @generated from enum value: CANT_REQUEST_TO_JOIN_TEAM_DOMAIN_NOT_MATCHED = 5;
   */
  CANT_REQUEST_TO_JOIN_TEAM_DOMAIN_NOT_MATCHED = 5,
}

/**
 * Describes the enum pi_customer_public.RequestToJoinTeamStatus.
 */
export const RequestToJoinTeamStatusSchema: GenEnum<RequestToJoinTeamStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 8);

/**
 * @generated from enum pi_customer_public.ResendRequestToJoinStatus
 */
export enum ResendRequestToJoinStatus {
  /**
   * @generated from enum value: RESEND_REQUEST_TO_JOIN_STATUS_UNSPECIFIED = 0;
   */
  RESEND_REQUEST_TO_JOIN_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESEND_REQUEST_TO_JOIN_SUCCESS = 1;
   */
  RESEND_REQUEST_TO_JOIN_SUCCESS = 1,

  /**
   * indicates that join to team request with provided id not exists
   *
   * @generated from enum value: CANT_RESEND_REQUEST_TO_JOIN_NOT_EXISTS = 2;
   */
  CANT_RESEND_REQUEST_TO_JOIN_NOT_EXISTS = 2,

  /**
   * only user that created request can resend emails for it,
   * if another user will try to resend emails for this request then this status will be returned
   *
   * @generated from enum value: CANT_RESEND_REQUEST_TO_JOIN_PERMISSION_DENIED = 3;
   */
  CANT_RESEND_REQUEST_TO_JOIN_PERMISSION_DENIED = 3,

  /**
   * @generated from enum value: CANT_RESEND_REQUEST_TO_JOIN_MISSING_REQUEST_ID = 4;
   */
  CANT_RESEND_REQUEST_TO_JOIN_MISSING_REQUEST_ID = 4,
}

/**
 * Describes the enum pi_customer_public.ResendRequestToJoinStatus.
 */
export const ResendRequestToJoinStatusSchema: GenEnum<ResendRequestToJoinStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 9);

/**
 * @generated from enum pi_customer_public.CancelMyRequestToJoinTeamStatus
 */
export enum CancelMyRequestToJoinTeamStatus {
  /**
   * @generated from enum value: CANCEL_MY_REQUEST_TO_JOIN_UNSPESIFIED = 0;
   */
  CANCEL_MY_REQUEST_TO_JOIN_UNSPESIFIED = 0,

  /**
   * @generated from enum value: CANCEL_MY_REQUEST_TO_JOIN_SUCCESS = 1;
   */
  CANCEL_MY_REQUEST_TO_JOIN_SUCCESS = 1,

  /**
   * indicates that join to team request with provided id not exists
   *
   * @generated from enum value: CANT_CANCEL_MY_REQUEST_TO_JOIN_NOT_EXISTS = 2;
   */
  CANT_CANCEL_MY_REQUEST_TO_JOIN_NOT_EXISTS = 2,

  /**
   * indicates that current user is not the owner of request
   *
   * @generated from enum value: CANT_CANCEL_MY_REQUEST_TO_JOIN_PERMISSION_DENIED = 3;
   */
  CANT_CANCEL_MY_REQUEST_TO_JOIN_PERMISSION_DENIED = 3,

  /**
   * @generated from enum value: CANT_CANCEL_MY_REQUEST_TO_JOIN_MISSING_REQUEST_ID = 4;
   */
  CANT_CANCEL_MY_REQUEST_TO_JOIN_MISSING_REQUEST_ID = 4,
}

/**
 * Describes the enum pi_customer_public.CancelMyRequestToJoinTeamStatus.
 */
export const CancelMyRequestToJoinTeamStatusSchema: GenEnum<CancelMyRequestToJoinTeamStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 10);

/**
 * @generated from enum pi_customer_public.ApproveRequestToJoinTeamStatus
 */
export enum ApproveRequestToJoinTeamStatus {
  /**
   * @generated from enum value: APPROVE_REQUEST_TO_JOIN_TEAM_UNSPECIFIED = 0;
   */
  APPROVE_REQUEST_TO_JOIN_TEAM_UNSPECIFIED = 0,

  /**
   * @generated from enum value: APPROVE_REQUEST_TO_JOIN_TEAM_SUCCESS = 1;
   */
  APPROVE_REQUEST_TO_JOIN_TEAM_SUCCESS = 1,

  /**
   * request with such id not found
   *
   * @generated from enum value: CANT_APPROVE_REQUEST_TO_JOIN_TEAM_NOT_EXISTS = 2;
   */
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_NOT_EXISTS = 2,

  /**
   * can't find team in database
   *
   * @generated from enum value: CANT_APPROVE_REQUEST_TO_JOIN_TEAM_INVALID_TEAM = 3;
   */
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_INVALID_TEAM = 3,

  /**
   * USER ADMIN or OWNER can assign any authority. MANAGER can assign only up to MANAGER
   *
   * @generated from enum value: CANT_APPROVE_REQUEST_TO_JOIN_TEAM_AUTHORITY_TOO_HIGH = 4;
   */
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_AUTHORITY_TOO_HIGH = 4,

  /**
   * user that created request not found in database. Probably account has been already removed.
   *
   * @generated from enum value: CANT_APPROVE_REQUEST_TO_JOIN_TEAM_USER_NOT_FOUND = 5;
   */
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_USER_NOT_FOUND = 5,

  /**
   * @generated from enum value: CANT_APPROVE_REQUEST_TO_JOIN_TEAM_MISSING_REQUEST_ID = 6;
   */
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_MISSING_REQUEST_ID = 6,

  /**
   * has to be one of MEMBER, USER_ADMIN, MANAGER, OWNER
   *
   * @generated from enum value: CANT_APPROVE_REQUEST_TO_JOIN_TEAM_INVALID_AUTHORITY_TO_ASSIGN = 7;
   */
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_INVALID_AUTHORITY_TO_ASSIGN = 7,

  /**
   * current user has to be USER_ADMIN, MANAGER or OWNER
   *
   * @generated from enum value: CANT_APPROVE_REQUEST_TO_JOIN_TEAM_NOT_ENOUGH_PERMISSIONS = 8;
   */
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_NOT_ENOUGH_PERMISSIONS = 8,

  /**
   * @generated from enum value: CANT_APPROVE_REQUEST_TO_JOIN_TEAM_ALREADY_A_MEMBER = 9;
   */
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_ALREADY_A_MEMBER = 9,

  /**
   * current team plan doesn't allow to add another user
   *
   * @generated from enum value: CANT_APPROVE_REQUEST_TO_JOIN_TEAM_MAX_USERS_REACHED = 10;
   */
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_MAX_USERS_REACHED = 10,
}

/**
 * Describes the enum pi_customer_public.ApproveRequestToJoinTeamStatus.
 */
export const ApproveRequestToJoinTeamStatusSchema: GenEnum<ApproveRequestToJoinTeamStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 11);

/**
 * @generated from enum pi_customer_public.DeclineRequestToJoinTeamStatus
 */
export enum DeclineRequestToJoinTeamStatus {
  /**
   * @generated from enum value: DECLINE_REQUEST_TO_JOIN_TEAM_UNSPECIFIED = 0;
   */
  DECLINE_REQUEST_TO_JOIN_TEAM_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DECLINE_REQUEST_TO_JOIN_TEAM_SUCCESS = 1;
   */
  DECLINE_REQUEST_TO_JOIN_TEAM_SUCCESS = 1,

  /**
   * request with such id not exists
   *
   * @generated from enum value: CANT_DECLINE_REQUEST_TO_JOIN_TEAM_NOT_EXISTS = 2;
   */
  CANT_DECLINE_REQUEST_TO_JOIN_TEAM_NOT_EXISTS = 2,

  /**
   * can't find team in database
   *
   * @generated from enum value: CANT_DECLINE_REQUEST_TO_JOIN_TEAM_INVALID_TEAM = 3;
   */
  CANT_DECLINE_REQUEST_TO_JOIN_TEAM_INVALID_TEAM = 3,

  /**
   * @generated from enum value: CANT_DECLINE_REQUEST_TO_JOIN_TEAM_MISSING_REQUEST_ID = 4;
   */
  CANT_DECLINE_REQUEST_TO_JOIN_TEAM_MISSING_REQUEST_ID = 4,

  /**
   * current user has to be USER_ADMIN, MANAGER or OWNER
   *
   * @generated from enum value: CANT_DECLINE_REQUEST_TO_JOIN_TEAM_MOT_ENOUGH_PERMISSIONS = 5;
   */
  CANT_DECLINE_REQUEST_TO_JOIN_TEAM_MOT_ENOUGH_PERMISSIONS = 5,
}

/**
 * Describes the enum pi_customer_public.DeclineRequestToJoinTeamStatus.
 */
export const DeclineRequestToJoinTeamStatusSchema: GenEnum<DeclineRequestToJoinTeamStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 12);

/**
 * Represents user's membership status in a Team
 *
 * @generated from enum pi_customer_public.MembershipStatus
 */
export enum MembershipStatus {
  /**
   * @generated from enum value: MEMBERSHIP_STATUS_UNSPECIFIED = 0;
   */
  MEMBERSHIP_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: PENDING = 2 [deprecated = true];
   * @deprecated
   */
  PENDING = 2,

  /**
   * @generated from enum value: INACTIVE = 3;
   */
  INACTIVE = 3,

  /**
   * @generated from enum value: ANONYMOUS = 4;
   */
  ANONYMOUS = 4,

  /**
   * @generated from enum value: ACCOUNT_DELETED = 5;
   */
  ACCOUNT_DELETED = 5,

  /**
   * deprecated in favor of MembershipOrigin
   *
   * @generated from enum value: TEMPORARY_FOR_WT_SUPPORT = 6 [deprecated = true];
   * @deprecated
   */
  TEMPORARY_FOR_WT_SUPPORT = 6,
}

/**
 * Describes the enum pi_customer_public.MembershipStatus.
 */
export const MembershipStatusSchema: GenEnum<MembershipStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 13);

/**
 * @generated from enum pi_customer_public.CancelMembershipStatus
 */
export enum CancelMembershipStatus {
  /**
   * @generated from enum value: CANCEL_MEMBERSHIP_UNSPECIFIED = 0;
   */
  CANCEL_MEMBERSHIP_UNSPECIFIED = 0,

  /**
   * @generated from enum value: CANCEL_MEMBERSHIP_SUCCESS = 1;
   */
  CANCEL_MEMBERSHIP_SUCCESS = 1,

  /**
   * @generated from enum value: CANT_CANCEL_NOT_A_TEAM_OWNER = 2 [deprecated = true];
   * @deprecated
   */
  CANT_CANCEL_NOT_A_TEAM_OWNER = 2,

  /**
   * Logged user has to be owner or user admin
   *
   * @generated from enum value: CANT_CANCEL_NOT_ENOUGH_PERMISSIONS = 2;
   */
  CANT_CANCEL_NOT_ENOUGH_PERMISSIONS = 2,

  /**
   * Can't cancel membership of the logged user. There won't be any user left to manage the team members.
   *
   * @generated from enum value: CANT_CANCEL_LAST_TEAM_ONWER = 3;
   */
  CANT_CANCEL_LAST_TEAM_ONWER = 3,

  /**
   * @generated from enum value: CANT_CANCEL_MEMBERSHIP_NOT_FOUND = 4;
   */
  CANT_CANCEL_MEMBERSHIP_NOT_FOUND = 4,
}

/**
 * Describes the enum pi_customer_public.CancelMembershipStatus.
 */
export const CancelMembershipStatusSchema: GenEnum<CancelMembershipStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 14);

/**
 * @generated from enum pi_customer_public.ActivateMembershipStatus
 */
export enum ActivateMembershipStatus {
  /**
   * @generated from enum value: ACTIVATE_MEMBERSHIP_UNSPECIFIED = 0;
   */
  ACTIVATE_MEMBERSHIP_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACTIVATE_MEMBERSHIP_SUCCESS = 1;
   */
  ACTIVATE_MEMBERSHIP_SUCCESS = 1,

  /**
   * @generated from enum value: CANT_ACTIVATE_NOT_A_TEAM_OWNER = 2 [deprecated = true];
   * @deprecated
   */
  CANT_ACTIVATE_NOT_A_TEAM_OWNER = 2,

  /**
   * Logged user have to be owner or user admin
   *
   * @generated from enum value: CANT_ACTIVATE_NOT_ENOUGH_PERMISSIONS = 2;
   */
  CANT_ACTIVATE_NOT_ENOUGH_PERMISSIONS = 2,

  /**
   * current team plan does not allow to add more users
   *
   * @generated from enum value: CANT_ACTIVATE_USERS_LIMIT_REACHED = 3;
   */
  CANT_ACTIVATE_USERS_LIMIT_REACHED = 3,
}

/**
 * Describes the enum pi_customer_public.ActivateMembershipStatus.
 */
export const ActivateMembershipStatusSchema: GenEnum<ActivateMembershipStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 15);

/**
 * @generated from enum pi_customer_public.ForgetTeamMemberStatus
 */
export enum ForgetTeamMemberStatus {
  /**
   * @generated from enum value: FORGET_TEAM_MEMBER_UNSPECIFIED = 0;
   */
  FORGET_TEAM_MEMBER_UNSPECIFIED = 0,

  /**
   * @generated from enum value: FORGET_TEAM_MEMBER_SUCCESS = 1;
   */
  FORGET_TEAM_MEMBER_SUCCESS = 1,

  /**
   * @generated from enum value: CANT_FORGET_TEAM_MEMBER_NOT_A_TEAM_OWNER = 2 [deprecated = true];
   * @deprecated
   */
  CANT_FORGET_TEAM_MEMBER_NOT_A_TEAM_OWNER = 2,

  /**
   * Logged user have to be owner or user admin
   *
   * @generated from enum value: CANT_FORGET_TEAM_MEMBER_NOT_ENOUGH_PERMISSIONS = 2;
   */
  CANT_FORGET_TEAM_MEMBER_NOT_ENOUGH_PERMISSIONS = 2,

  /**
   * @generated from enum value: CANT_FORGET_LAST_TEAM_OWNER = 3;
   */
  CANT_FORGET_LAST_TEAM_OWNER = 3,
}

/**
 * Describes the enum pi_customer_public.ForgetTeamMemberStatus.
 */
export const ForgetTeamMemberStatusSchema: GenEnum<ForgetTeamMemberStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 16);

/**
 * @generated from enum pi_customer_public.ForgottenStatus
 */
export enum ForgottenStatus {
  /**
   * @generated from enum value: FORGOTTEN_STATUS_UNSPECIFIED = 0;
   */
  FORGOTTEN_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: FORGOTTEN_SUCCESS = 1;
   */
  FORGOTTEN_SUCCESS = 1,

  /**
   * Can happen if not a member, membership already anonimyzed or right to be forgotten already invoked
   *
   * @generated from enum value: FORGOTTEN_FAILED_MEMBERSHIP_NOT_FOUND = 2;
   */
  FORGOTTEN_FAILED_MEMBERSHIP_NOT_FOUND = 2,
}

/**
 * Describes the enum pi_customer_public.ForgottenStatus.
 */
export const ForgottenStatusSchema: GenEnum<ForgottenStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 17);

/**
 * @generated from enum pi_customer_public.UpdateAuthorityStatus
 */
export enum UpdateAuthorityStatus {
  /**
   * @generated from enum value: UPDATE_AUTHORITY_UNSPECIFIED = 0;
   */
  UPDATE_AUTHORITY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPDATE_AUTHORITY_SUCCESS = 1;
   */
  UPDATE_AUTHORITY_SUCCESS = 1,

  /**
   * Logged user is not an owner of the given team.
   *
   * @generated from enum value: CANT_DEGRADE_NOT_A_TEAM_OWNER = 2;
   */
  CANT_DEGRADE_NOT_A_TEAM_OWNER = 2,

  /**
   * Can't degrade team's owner permission. There won't be any user left to manage the team members.
   *
   * @generated from enum value: CANT_DEGRADE_LAST_TEAM_OWNER = 3;
   */
  CANT_DEGRADE_LAST_TEAM_OWNER = 3,

  /**
   * Assigner with a Member authority can't update authority.
   *
   * @generated from enum value: CANT_UPDATE_ASSIGNER_IS_MEMBER = 4;
   */
  CANT_UPDATE_ASSIGNER_IS_MEMBER = 4,

  /**
   * The assignee is higher in the hierarchy, than logged user (assigner).
   *
   * @generated from enum value: CANT_UPDATE_ASSIGNEE_HAS_HIGHER_AUTHORITY = 5;
   */
  CANT_UPDATE_ASSIGNEE_HAS_HIGHER_AUTHORITY = 5,

  /**
   * The assigner can only assign an authority that is at up to the same level than their own authority.
   *
   * @generated from enum value: CANT_ASSIGN_HIGHER_THAN_OWN_AUTHORITY = 6;
   */
  CANT_ASSIGN_HIGHER_THAN_OWN_AUTHORITY = 6,

  /**
   * The assigner's membership to team could not be found.
   *
   * @generated from enum value: CANT_UPDATE_ASSIGNER_NOT_FOUND = 7;
   */
  CANT_UPDATE_ASSIGNER_NOT_FOUND = 7,

  /**
   * The assignee's membership to team could not be found.
   *
   * @generated from enum value: CANT_UPDATE_ASSIGNEE_NOT_FOUND = 8;
   */
  CANT_UPDATE_ASSIGNEE_NOT_FOUND = 8,
}

/**
 * Describes the enum pi_customer_public.UpdateAuthorityStatus.
 */
export const UpdateAuthorityStatusSchema: GenEnum<UpdateAuthorityStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_customer_user_team, 18);

/**
 * @generated from service pi_customer_public.UserTeamService
 */
export const UserTeamService: GenService<{
  /**
   *
   * Disallow a user, who participates in an organization, to create a team with a name (case insensitive) that already
   * exists in the same organization.
   *
   * @generated from rpc pi_customer_public.UserTeamService.CreateTeam
   */
  createTeam: {
    methodKind: "unary";
    input: typeof CreateTeamRequestSchema;
    output: typeof CreateTeamResponseSchema;
  },
  /**
   * *
   * Requires team MEMBER authority, if the team doesn't exist GetTeamResponse won't have a team
   *
   * @generated from rpc pi_customer_public.UserTeamService.GetTeam
   */
  getTeam: {
    methodKind: "unary";
    input: typeof GetTeamRequestSchema;
    output: typeof GetTeamResponseSchema;
  },
  /**
   * *
   * Returns two lists of teams:
   * 1. where the user's status is active.
   * 2. where the user's status is inactive (i.e. user left the team but didn't invoke the right to be forgotten).
   * If the user is/was not a member of any team, GetMyTeamsResponse won't have any.
   *
   * @generated from rpc pi_customer_public.UserTeamService.GetMyTeams
   */
  getMyTeams: {
    methodKind: "unary";
    input: typeof GetMyTeamsRequestSchema;
    output: typeof GetMyTeamsResponseSchema;
  },
  /**
   * *
   * Requires team OWNER or USER ADMIN authority
   *
   * @generated from rpc pi_customer_public.UserTeamService.UpdateTeam
   */
  updateTeam: {
    methodKind: "unary";
    input: typeof UpdateTeamRequestSchema;
    output: typeof UpdateTeamResponseSchema;
  },
  /**
   * *
   * Requires team OWNER or USER ADMIN authority
   *
   * @generated from rpc pi_customer_public.UserTeamService.UpdateTeamName
   */
  updateTeamName: {
    methodKind: "unary";
    input: typeof UpdateTeamNameRequestSchema;
    output: typeof UpdateTeamNameResponseSchema;
  },
  /**
   * *
   * Requires team OWNER or USER ADMIN authority
   *
   * @generated from rpc pi_customer_public.UserTeamService.UploadTeamLogo
   */
  uploadTeamLogo: {
    methodKind: "unary";
    input: typeof UploadTeamLogoRequestSchema;
    output: typeof UploadTeamLogoResponseSchema;
  },
  /**
   * *
   * Known callers: customer-frontend (from the team settings page)
   * Requires team OWNER or USER ADMIN authority
   *
   * @generated from rpc pi_customer_public.UserTeamService.SetTeamRoundingPreference
   */
  setTeamRoundingPreference: {
    methodKind: "unary";
    input: typeof SetTeamRoundingPreferenceRequestSchema;
    output: typeof SetTeamRoundingPreferenceResponseSchema;
  },
  /**
   * *
   * Known callers: customer-frontend (from the team settings page)
   * Requires team OWNER or USER ADMIN authority
   *
   * @generated from rpc pi_customer_public.UserTeamService.SetDirectTimelinePostPreference
   */
  setDirectTimelinePostPreference: {
    methodKind: "unary";
    input: typeof SetDirectTimelinePostPreferenceRequestSchema;
    output: typeof SetDirectTimelinePostPreferenceResponseSchema;
  },
  /**
   * *
   * Requires team OWNER authority
   *
   * @generated from rpc pi_customer_public.UserTeamService.DeleteTeam
   */
  deleteTeam: {
    methodKind: "unary";
    input: typeof DeleteTeamRequestSchema;
    output: typeof DeleteTeamResponseSchema;
  },
  /**
   * *
   * Requires team authority higher than MEMBER e.g. USER_ADMIN, MANAGER, OWNER.
   *
   * @generated from rpc pi_customer_public.UserTeamService.ListTeamInvitations
   */
  listTeamInvitations: {
    methodKind: "unary";
    input: typeof ListTeamInvitationsRequestSchema;
    output: typeof ListTeamInvitationsResponseSchema;
  },
  /**
   * *
   * Requires team authority higher than MEMBER e.g. USER_ADMIN, MANAGER, OWNER.
   *
   * @generated from rpc pi_customer_public.UserTeamService.InviteUsers
   */
  inviteUsers: {
    methodKind: "unary";
    input: typeof InviteUsersRequestSchema;
    output: typeof InviteUsersResponseSchema;
  },
  /**
   * @generated from rpc pi_customer_public.UserTeamService.AcceptTeamJoinInvite
   */
  acceptTeamJoinInvite: {
    methodKind: "unary";
    input: typeof AcceptTeamJoinInviteRequestSchema;
    output: typeof AcceptTeamJoinInviteResponseSchema;
  },
  /**
   * *
   * Requires team authority higher than MEMBER e.g. USER_ADMIN, MANAGER, OWNER.
   *
   * @generated from rpc pi_customer_public.UserTeamService.ResendInvitation
   */
  resendInvitation: {
    methodKind: "unary";
    input: typeof ResendInvitationRequestSchema;
    output: typeof ResendInvitationResponseSchema;
  },
  /**
   * *
   * Requires team OWNER or USER ADMIN authority
   *
   * @generated from rpc pi_customer_public.UserTeamService.CancelInvitation
   */
  cancelInvitation: {
    methodKind: "unary";
    input: typeof CancelInvitationRequestSchema;
    output: typeof CancelInvitationResponseSchema;
  },
  /**
   * *
   * Suggest teams for the user to join, based on their email address.
   *
   * The email domain (or sub-domain) will be matched with domains related to an organisation, and the organisation's
   * teams will be returned. The list of teams will only contain teams that the user isn't already a member of.
   *
   * @generated from rpc pi_customer_public.UserTeamService.SuggestTeams
   */
  suggestTeams: {
    methodKind: "unary";
    input: typeof SuggestTeamsRequestSchema;
    output: typeof SuggestTeamsResponseSchema;
  },
  /**
   * *
   * Create a team join request record and emails the request to team owners, user admins and managers.
   *
   * @generated from rpc pi_customer_public.UserTeamService.RequestToJoinTeam
   */
  requestToJoinTeam: {
    methodKind: "unary";
    input: typeof RequestToJoinTeamRequestSchema;
    output: typeof RequestToJoinTeamResponseSchema;
  },
  /**
   * *
   * List the current user's team join requests.
   *
   * The current user identified via the request ID token.
   *
   * @generated from rpc pi_customer_public.UserTeamService.ListMyPendingTeamJoinRequests
   */
  listMyPendingTeamJoinRequests: {
    methodKind: "unary";
    input: typeof ListMyPendingTeamJoinRequestsRequestSchema;
    output: typeof ListMyPendingTeamJoinRequestsResponseSchema;
  },
  /**
   * *
   * Resend the request to join emails to team owners, user admins and managers.
   *
   * The current user identified via the request ID token.
   * Returns gRPC status NOT_FOUND if the request is not found, or if the request does not belong to the current user.
   *
   * @generated from rpc pi_customer_public.UserTeamService.ResendRequestToJoinTeam
   */
  resendRequestToJoinTeam: {
    methodKind: "unary";
    input: typeof ResendRequestToJoinTeamRequestSchema;
    output: typeof ResendRequestToJoinTeamResponseSchema;
  },
  /**
   * *
   * Cancel the current user's request to join a team by deleting the team join request record.
   *
   * The current user identified via the request ID token.
   * Returns gRPC status NOT_FOUND if the request is not found, or if the request does not belong to the current user.
   *
   * @generated from rpc pi_customer_public.UserTeamService.CancelMyRequestToJoinTeam
   */
  cancelMyRequestToJoinTeam: {
    methodKind: "unary";
    input: typeof CancelMyRequestToJoinTeamRequestSchema;
    output: typeof CancelMyRequestToJoinTeamResponseSchema;
  },
  /**
   * *
   * List team join requests for the team.
   *
   * The current user must be a team owner, user admin or manager. Returns gRPC status PERMISSION_DENIED otherwise.
   *
   * @generated from rpc pi_customer_public.UserTeamService.ListTeamJoinRequests
   */
  listTeamJoinRequests: {
    methodKind: "unary";
    input: typeof ListTeamJoinRequestsRequestSchema;
    output: typeof ListTeamJoinRequestsResponseSchema;
  },
  /**
   * *
   * Approve team join request and creates a new team membership for the requestee.
   *
   * The current user can only assign an authority that is at up to the same level than their own.
   * Except if the current user is a user admin. A user admin can assign any authority to the new membership.
   *
   * The current user must be a team owner, user admin or manager. Returns gRPC status PERMISSION_DENIED otherwise.
   * Returns gRPC status NOT_FOUND if the team join request is not found.
   *
   * @generated from rpc pi_customer_public.UserTeamService.ApproveRequestToJoinTeam
   */
  approveRequestToJoinTeam: {
    methodKind: "unary";
    input: typeof ApproveRequestToJoinTeamRequestSchema;
    output: typeof ApproveRequestToJoinTeamResponseSchema;
  },
  /**
   * *
   * Decline team join request. The requestee is not informed of the fact.
   *
   * The current user must be a team owner, user admin or manager. Returns gRPC status PERMISSION_DENIED otherwise.
   * Returns gRPC status NOT_FOUND if the team join request is not found.
   *
   * @generated from rpc pi_customer_public.UserTeamService.DeclineRequestToJoinTeam
   */
  declineRequestToJoinTeam: {
    methodKind: "unary";
    input: typeof DeclineRequestToJoinTeamRequestSchema;
    output: typeof DeclineRequestToJoinTeamResponseSchema;
  },
  /**
   * *
   * Requires team authority higher than MEMBER e.g. USER_ADMIN, MANAGER, OWNER.
   *
   * @generated from rpc pi_customer_public.UserTeamService.ListTeamMemberships
   */
  listTeamMemberships: {
    methodKind: "unary";
    input: typeof ListTeamMembershipsRequestSchema;
    output: typeof ListTeamMembershipsResponseSchema;
  },
  /**
   * *
   * Team OWNER and USER ADMIN can update team membership for any user.
   * For others this method depends on the authority that the current user has within the team.
   * The current user can only update a member that is at up to the same level
   * than their own authority.
   *
   * @generated from rpc pi_customer_public.UserTeamService.UpdateTeamMembership
   */
  updateTeamMembership: {
    methodKind: "unary";
    input: typeof UpdateTeamMembershipRequestSchema;
    output: typeof UpdateTeamMembershipResponseSchema;
  },
  /**
   * *
   * Disables / deactivates a user's membership to a team; sets the membership status to `INACTIVE`.
   *
   * Requires team OWNER or USER ADMIN authority
   *
   * @generated from rpc pi_customer_public.UserTeamService.CancelMembership
   */
  cancelMembership: {
    methodKind: "unary";
    input: typeof CancelMembershipRequestSchema;
    output: typeof CancelMembershipResponseSchema;
  },
  /**
   * *
   * Activates a user's membership to a team; sets the membership status to `ACTIVE`.
   *
   * Requires team OWNER or USER ADMIN authority.
   *
   * @generated from rpc pi_customer_public.UserTeamService.ActivateMembership
   */
  activateMembership: {
    methodKind: "unary";
    input: typeof ActivateMembershipRequestSchema;
    output: typeof ActivateMembershipResponseSchema;
  },
  /**
   * *
   * Sets the membership status to `ANONYMOUS` and fakes member name and email.
   *
   * Requires team OWNER or USER ADMIN authority.
   *
   * @generated from rpc pi_customer_public.UserTeamService.ForgetTeamMember
   */
  forgetTeamMember: {
    methodKind: "unary";
    input: typeof ForgetTeamMemberRequestSchema;
    output: typeof ForgetTeamMemberResponseSchema;
  },
  /**
   * *
   * Called when a user invokes right to be forgotten after leaving the team.
   * Unlike `ForgetTeamMember` this endpoint won't anonymize membership immediately,
   * it will schedule anonymization in a month.
   *
   * Can be invoked by a user by themself only.
   *
   * @generated from rpc pi_customer_public.UserTeamService.InvokeRightToBeForgotten
   */
  invokeRightToBeForgotten: {
    methodKind: "unary";
    input: typeof InvokeRightToBeForgottenRequestSchema;
    output: typeof InvokeRightToBeForgottenResponseSchema;
  },
  /**
   * *
   * The authority that can be assigned depends on the authority that the current user has
   * within the team. Team OWNER and USER ADMIN can assign any authority to other users.
   * USER ADMIN can't promote himself to MANAGER OR OWNER, can promote other users to MANAGERs and OWNERs though.
   * Others can only assign an authority that is at up to the same level than their own authority.
   *
   * @generated from rpc pi_customer_public.UserTeamService.UpdateAuthority
   */
  updateAuthority: {
    methodKind: "unary";
    input: typeof UpdateAuthorityRequestSchema;
    output: typeof UpdateAuthorityResponseSchema;
  },
  /**
   * *
   * Requires team MEMBER authority
   *
   * @generated from rpc pi_customer_public.UserTeamService.ListBusinessRoles
   */
  listBusinessRoles: {
    methodKind: "unary";
    input: typeof ListBusinessRolesRequestSchema;
    output: typeof ListBusinessRolesResponseSchema;
  },
  /**
   * *
   * Requires team OWNER or USER ADMIN authority
   *
   * @generated from rpc pi_customer_public.UserTeamService.CreateBusinessRole
   */
  createBusinessRole: {
    methodKind: "unary";
    input: typeof CreateBusinessRoleRequestSchema;
    output: typeof CreateBusinessRoleResponseSchema;
  },
  /**
   * *
   * Requires team OWNER or USER ADMIN authority
   *
   * @generated from rpc pi_customer_public.UserTeamService.UpdateBusinessRole
   */
  updateBusinessRole: {
    methodKind: "unary";
    input: typeof UpdateBusinessRoleRequestSchema;
    output: typeof UpdateBusinessRoleResponseSchema;
  },
  /**
   * *
   * Requires team OWNER or USER ADMIN authority
   *
   * @generated from rpc pi_customer_public.UserTeamService.DeleteBusinessRole
   */
  deleteBusinessRole: {
    methodKind: "unary";
    input: typeof DeleteBusinessRoleRequestSchema;
    output: typeof DeleteBusinessRoleResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_wt_svc_customer_user_team, 0);

